import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Cable, Droplets, Wind, Flame, Zap, Gauge } from "lucide-react";
import { motion } from "framer-motion";

const calculations = [
  {
    icon: Cable,
    title: "Voltage Drop Calculator",
    description: "Cable sizing with NEC/IEC validation",
    category: "Electrical",
    color: "text-amber-500",
  },
  {
    icon: Droplets,
    title: "Pump Head Calculator",
    description: "Hydraulic calculations for pumps",
    category: "Plumbing",
    color: "text-blue-500",
  },
  {
    icon: Wind,
    title: "Fan Static Pressure",
    description: "HVAC duct pressure calculations",
    category: "HVAC",
    color: "text-cyan-500",
  },
  {
    icon: Flame,
    title: "Fire Pump Validation",
    description: "NFPA compliance verification",
    category: "Firefighting",
    color: "text-red-500",
  },
  {
    icon: Zap,
    title: "Transformer Sizing",
    description: "Load calculations & selection",
    category: "Electrical",
    color: "text-amber-500",
  },
  {
    icon: Gauge,
    title: "Duct Sizing",
    description: "Equal friction & static regain",
    category: "HVAC",
    color: "text-cyan-500",
  },
];

export function CalculationsSection() {
  return (
    <section id="calculations" className="py-24">
      <div className="container">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <motion.h2 
            className="mb-4 text-3xl font-bold md:text-4xl"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Professional Engineering Calculations
          </motion.h2>
          <motion.p 
            className="text-lg text-muted-foreground"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            50+ automated calculations with code validation and exportable reports
          </motion.p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {calculations.map((calc, index) => (
            <motion.div
              key={calc.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card className="group h-full cursor-pointer border-border/40 transition-all hover:border-primary/50 hover:shadow-lg">
                <CardHeader>
                  <div className="mb-3 flex items-center justify-between">
                    <div className={`flex h-10 w-10 items-center justify-center rounded-lg bg-muted transition-colors group-hover:bg-primary/10 ${calc.color}`}>
                      <calc.icon className="h-5 w-5" />
                    </div>
                    <Badge variant="secondary" className="text-xs">
                      {calc.category}
                    </Badge>
                  </div>
                  <CardTitle className="text-lg">{calc.title}</CardTitle>
                  <CardDescription>{calc.description}</CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="text-sm text-muted-foreground">
                    Click to calculate →
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
